module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/impressionsIcon.82a6e3b5.svg";